import type { Reducer } from 'redux';
import {
  ADD_SESSION,
  REMOVE_SESSION,
  INVALID_SESSION,
  LIMIT_REACHED,
  type SessionAction,
} from '../actions';

export interface SessionState {
  meta?: { type?: string; id?: string };
  valid?: boolean;
  limitReached?: boolean;
  [key: string]: any;
}

const initialState: SessionState | null = null;

const reducer: Reducer<SessionState | null, SessionAction> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case ADD_SESSION: {
      const data = action.data as SessionState;
      if (data?.meta?.type !== 'session') {
        return state;
      }
      return { ...(state || {}), ...data, valid: true };
    }
    case REMOVE_SESSION:
      return initialState;
    case INVALID_SESSION:
      if (state && state.meta && state.meta.id) {
        return { ...state, valid: false };
      }
      return state;
    case LIMIT_REACHED:
      if (state && state.meta && state.meta.id) {
        return { ...state, limitReached: true };
      }
      return state;
    default:
      return state;
  }
};

export default reducer;
